import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, mergeMap, switchMap } from 'rxjs/operators';

import { createEffectFactory } from '@recruitee/ngrx';

import { PersonalTokenHttpClient } from './personal-token.http-client';
import { PersonalTokenActions, actions } from './personal-token.store';

@Injectable({ providedIn: 'root' })
export class PersonalTokenEffects {
  public effects = createEffectFactory(actions, this.actions$);

  public fetchCollection$ = this.effects(PersonalTokenActions.fetchCollection, ({ payload }) =>
    this.personalTokenHttpClient.fetchCollection().pipe(map(data => ({ data }))),
  );

  public fetchOne$ = this.effects(PersonalTokenActions.fetchOne, ({ payload }) =>
    this.personalTokenHttpClient.fetchOne(payload).pipe(map(data => ({ data }))),
  );

  public createOnePessimistic$ = this.effects(
    PersonalTokenActions.createOnePessimistic,
    ({ payload }) =>
      this.personalTokenHttpClient
        .create({
          name: payload.data.name,
          secureChangeToken: payload.data.secureChangeToken,
        })
        .pipe(map(data => ({ data }))),
  );

  public removeOnePessimistic$ = createEffect(() =>
    this.actions$.pipe(
      ofType(PersonalTokenActions.removeOnePessimistic),
      mergeMap(({ payload }) =>
        this.personalTokenHttpClient
          .delete({ id: payload.id, secureChangeToken: payload.secureChangeToken })
          .pipe(
            switchMap(() => [
              PersonalTokenActions.removeOnePessimisticSuccess({
                payload: { id: payload.id },
              }),
            ]),
            catchError((error: HttpErrorResponse) =>
              of(
                PersonalTokenActions.removeOnePessimisticFailed({
                  payload: { data: payload.id, error },
                }),
              ),
            ),
          ),
      ),
    ),
  );

  public updateName$ = this.effects(PersonalTokenActions.updateName, ({ payload }) =>
    this.personalTokenHttpClient.updateName(payload.data).pipe(
      switchMap(data => [PersonalTokenActions.updateNameSuccess({ payload: { data } })]),
      catchError((error: HttpErrorResponse) =>
        of(PersonalTokenActions.updateNameFailed({ payload: { data: payload.data, error } })),
      ),
    ),
  );

  constructor(
    private actions$: Actions,
    private personalTokenHttpClient: PersonalTokenHttpClient,
  ) {}
}
